// extracted by mini-css-extract-plugin
export default {"Item":"style_Item__k0c8Z","title":"style_title__qiFWC"};